import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef} from "@angular/core";
import {
  TaskDto,
  ITaskDto
} from "src/app/web-api/web-api";
import { DragDropContainerComponent } from "src/app/common-components/drag-drop-container/drag-drop-container.component";
import { PlanungApiOverviewComponent } from "../planung-api-overview.component";

@Component({
    selector: "app-planung-task-drag-drop-list",
    templateUrl: "./task-drag-drop-list.component.html",
    styleUrls: ["./task-drag-drop-list.component.scss"],
    standalone: false
})
export class PlanungApiTaskDragDropListComponent {
  @Input() overview: PlanungApiOverviewComponent;
  @Input() tasks: TaskDto[];

  @Output() tasksDropped = new EventEmitter<ITaskDto[]>(false);

  @Input() itemClass = "col-12";
  @Input() taskDragDropListItemTemplate: TemplateRef<any>;


  public OnDragStart(
    _sender: DragDropContainerComponent,
    e: DragEvent,
    _data: any
  ) {
    this.overview.OnTasksDragStart(e, this.overview.selection.Items);
  }

  public OnDragOver(
    _sender: DragDropContainerComponent,
    e: DragEvent,
    _data: any
  ) {
    e.preventDefault();
    const hasTasks = e.dataTransfer.types.includes(this.overview.DragDropKey_tasks);
    if (!hasTasks) {
      e.dataTransfer.dropEffect = "none";
      return false;
    }
    e.dataTransfer.dropEffect = "move";
    return true;
  }

  public OnDrop(_sender: DragDropContainerComponent, e: DragEvent, _data: any) {
    e.preventDefault();
    const tasks = this.overview.GetTasksFromDragEvent(e);
    if (!tasks) {
      return;
    }
    this.overview.selection.Reset();
    if (this.tasksDropped) {
      this.tasksDropped.emit(
        tasks.map((x: ITaskDto) => {
          const task = new TaskDto();
          task.init(x);
          return task;
        })
      );
    }
  }

  public OnSelectTask(ev: MouseEvent, task: TaskDto) {
    this.overview.selection.HandleItem(task, ev);
  }

  public GetSelectedStyle(task: TaskDto) {
    if (!this.overview.selection.IsItemSelected(task)) {
      return {};
    }
    return {
      border: "1px solid #009036",
      background: "#00903622",
      borderRadius: "10px",
    };
  }
}
